import React from 'react';
import { Route, Routes } from 'react-router-dom';

import { ComingSoon } from '../pages/ComingSoon';
import { Homepage } from '../pages/Homepage';
import { Privacy } from '../pages/Privacy';
import { Terms } from '../pages/Terms';
import { DeleteAccount } from '../pages/DeleteAccount';
import { Support } from '../pages/Support';

const Router: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<Homepage />} />
      {/* <Route path="/" element={<Homepage />} /> */}
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/delete-account" element={<DeleteAccount />} />
      <Route path="/support" element={<Support />} />
    </Routes>
  );
};

export { Router };
